export const getInputErrorA11yProps = (hasError, errorId) => ({
	...(hasError && {
		'aria-invalid': true,
		...(errorId && { 'aria-describedby': errorId }),
	}),
});

export const getErrorMessageA11yProps = (errorId) => ({
	id: errorId,
	role: 'alert',
});
